import { Base, Component, Mixins, Prop, Watch } from '@/vue-property-decorator'
import { GlobalConst } from '@/context'
import { useMainStore } from '@/store/index'
import OccupiedEmpty from './occupiedEmpty'
import UnitMixins from '@/mixins/unit'
import propsModule from './props'
import style from './style.module.scss'
import type {
  _CardListOneProps as CardListOneProps,
  _RowCardCount as RowCardCount
} from './props'
/** @deprecated 请使用 CardListOneProps 代替 Props ,Props 之后将被彻底删除 */
export type Props = CardListOneProps
// 导出类型
export { CardListOneProps, RowCardCount }
/** 卡片列表props配置的抽象基类 */
export const CardListOneConfigBase = propsModule.CardListOneConfigBase
/** 向外抛出的尺寸对象 */
export type EmitGridSize = {
  /** 网络宽度  单位px */
  widthPx: number
  /** 网络宽度  单位rem */
  widthRem: number
}
export type Events = {
  /** 向外抛出网络的尺寸事件 */
  onGetGridSize(param: EmitGridSize): void
}
type ListInnerStyle = {
  margin: string
  '--cardRowSpacing': string
  '--cardColSpacing': string
}
/** 游戏卡片
 * 正方型图片,结合文字
 */
@Component<ListOne>({
  name: 'ListOne'
})
export default class ListOne extends Mixins<
  Base<unknown, CardListOneProps, Events>,
  UnitMixins
>(Base, UnitMixins) {
  /** 无列表数据,空的占位符 */
  public static OccupiedEmpty = OccupiedEmpty

  @Prop({ default: 'auto' })
  private width!: Required<CardListOneProps>['width']
  @Prop({ default: undefined })
  private rowCardCount!: CardListOneProps['rowCardCount']
  @Prop({ default: 20 })
  private leftRightSpacing!: Required<CardListOneProps>['leftRightSpacing']
  @Prop({ default: 20 })
  private topBotSpacing!: Required<CardListOneProps>['topBotSpacing']
  @Prop({ default: false })
  private isNoWrap!: Required<CardListOneProps>['isNoWrap']
  @Prop({ default: false })
  private isEmpty!: Required<CardListOneProps>['isEmpty']

  /** 屏幕尺寸改变 rootFontSize初次赋值就是在mounted之后 */
  get rootFontSize() {
    return useMainStore().rootFontSize
  }

  @Watch('rootFontSize', { immediate: true })
  recalculateGridSizeByRootFontSize() {
    this.calculateGridSize()
  }

  /** 计算内部网络的尺寸 */
  private calculateGridSize() {
    const htmlFontSize = window.getComputedStyle(
      document.querySelector('html') as HTMLElement
    ).fontSize
    const { val: hFontSizeNum } = this.calculatLocalSize(htmlFontSize)
    /** px转换成rem的比例 */
    const remRatio = this.baseUnit / hFontSizeNum
    const { val: boxWidth } = this.calculatLocalSize(this.width)
    const { val: cardPadding } = this.calculatLocalSize(this.leftRightSpacing)
    const cardGridWidthRem =
      (boxWidth + cardPadding) / (this.rowCardCount as RowCardCount)
    const cardGridWidthPx = (cardGridWidthRem / remRatio) * 100
    this.$emit('getGridSize', {
      widthRem: cardGridWidthRem,
      widthPx: cardGridWidthPx
    } as EmitGridSize)
  }

  /** 盒子的宽度转换 */
  get localWidth() {
    let width: string
    if (typeof this.width === 'number') {
      width = this.width / this.baseUnit + this.unit
    } else {
      width = this.width
    }
    return width
  }

  /** 计算出内部盒子的样式 */
  get listInnerStyle() {
    const style = {} as ListInnerStyle
    const { leftRightSpacing, topBotSpacing } = this
    // 盒子的上下外边距
    const listTbMargin = this.calculateHalfSpacing(topBotSpacing)
    // 盒子的左右外边距
    const listLrMargin = this.calculateHalfSpacing(leftRightSpacing)
    style['--cardRowSpacing'] = listTbMargin
    // 如果没有设置 this.rowCardCount ,则进行散装排列,排不下就直接换行.
    if (!this.rowCardCount) {
      style['--cardColSpacing'] = listLrMargin
    }
    style.margin = `-${listTbMargin} -${listLrMargin}`
    return style
  }

  /** 计算间距值的一半 */
  private calculateHalfSpacing(spacing: number | string) {
    const { val, unit } = this.calculatLocalSize(spacing)
    return val / 2 + unit
  }

  /** 将外部传入尺寸转化为本组件使用的尺寸
   * @param size
   * @returns [val:数值] [unit:单位]
   */
  private calculatLocalSize(size: number | string) {
    /** 最终返回值 */
    const ret = { val: 0, unit: '' }
    // 如果是数字结尾的解析
    if (typeof size === 'number') {
      ret.val = size / this.baseUnit
      ret.unit = this.unit
    }
    // 如果是rem或是px结尾的,也正常解析
    else {
      if (/^\d+(\.\d+)?(rem|px)/.test(size)) {
        // 单位
        ret.unit = size.replace(/[0-9.]/g, '')
        // 数值
        ret.val = parseFloat(size.replace(/(px|rem)/g, ''))
      }
    }
    return ret
  }

  render() {
    const { rowCardCount } = this
    return !this.isEmpty && this.$slots?.default ? (
      <div
        class={{
          [style['list-one']]: true
        }}
        style={{ width: this.localWidth }}
      >
        <div
          style={this.listInnerStyle}
          class={{
            [style['list-inner']]: true,
            [GlobalConst.CssClassName.Lobby.CardScrollWrapList]: true, // 卡片的拖拽滚动类
            [style['list-inner-nowrap']]: this.isNoWrap,
            [style[`card-count-${rowCardCount as RowCardCount}`]]:
              Boolean(rowCardCount)
          }}
        >
          {this.$slots?.default}
        </div>
      </div>
    ) : (
      <OccupiedEmpty
        // 多增加一点权重,避免被其它地方覆盖
        class={[style['empty'], style['empty'], style['empty'], 'empty']}
      />
    )
  }
}
